







































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import numeral from 'numeral';
import uniq from 'lodash/uniq';

import { STORE_KEY, store } from './_store';
import ShiftClotsForm from './ShiftClotsForm/ShiftClotsForm.vue'
import ShiftClotsMultiForm from './ShiftClotsMultiForm/ShiftClotsMultiForm.vue'

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError',

      'relatedFactsList', 'meta'
    ]),
    ...mapState('ubic', [
      'token'
    ]),
    ...mapGetters(STORE_KEY, [
      'totals', 'finalRelatedFactsList', 'groupByFact'
    ]),
  },
})
export default class ShiftClots extends Vue {

  @Prop() documentId!: string;

  opened: any[] = [];
  public dropFiles = [];

  FILES_HOST = process.env.VUE_APP_UBIC_SERVER_ADDRESS;

  // items: any[] = [];

  formatNumber(value: any) {
    return numeral(value).format('0,0');
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    } else {
      this.$store.dispatch(`${STORE_KEY}/reset`)
    }
  }

  public mounted() {
    this.handleParamsChange();
  }

  public exportAsXLSX() {
    this.$store.dispatch(`${STORE_KEY}/exportAsXLSX`, {
      documentId: this.documentId,
    });
  }

  public handleParamsChange() {
    this.$store.dispatch(`${STORE_KEY}/loadData`, {
      documentId: this.documentId,
    });
  }

  openDocument(row: any, one_only: boolean) {
    const formName = row.volume_type == 'pail' ? ShiftClotsMultiForm : ShiftClotsForm;
    this.$buefy.modal.open({
      component: row.id || one_only ? ShiftClotsForm : formName,
      props: {
        isNew: !row || !row.id,
        documentPreview: row,
        documentId: this.documentId,
        volumeType: row.volume_type,
        initParams: {
          shift_id: this.documentId,
          ...row
        }
      },
      events: {
        'form-close': () => {
          this.handleParamsChange();
        },
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: 'document-form' + (row.id || one_only ? ' short-form' : ''),
      parent: this
    })
  }
}

